// extracted by mini-css-extract-plugin
module.exports = {"editModeToggler":"TextNode_editModeToggler__mJ2S3","editable":"TextNode_editable__RgL6W","wrapperMultiSelected":"TextNode_wrapperMultiSelected__uCvcN"};